import { Fragment } from 'react';

import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';
import { fieldValidateGuesser } from 'utils';

export const ReferenceArrayInputIntrospectedComponent = ({
  fields,
  validate,
  perPage = 1000,
  isFilter = false,
  ...props
}: any): JSX.Element => {
  const { guessedValidate, isError } = !isFilter
    ? fieldValidateGuesser({ fields, validate, ...props })
    : { guessedValidate: null, isError: false };

  if (isError) {
    return <Fragment />;
  }

  return (
    <ReferenceArrayInput validate={guessedValidate} {...props} perPage={perPage}>
      {props.children}
    </ReferenceArrayInput>
  );
};
